// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Generates parent props for autosuggest items based on the current item and last group index.
 * This logic is shared between plain-list and virtual-list implementations.
 */
export const getParentProps = (item, index, lastGroupIndex, virtualIndex) => {
    let updatedLastGroupIndex = lastGroupIndex;
    let parentProps = undefined;
    if (item.type === 'parent') {
        updatedLastGroupIndex = index;
    }
    else if (lastGroupIndex !== -1 && !!item.parent) {
        parentProps = {
            index: lastGroupIndex,
            virtualIndex: virtualIndex !== null && virtualIndex !== void 0 ? virtualIndex : lastGroupIndex,
            disabled: !!item.parent.disabled,
            option: {
                ...item.parent,
                disabled: !!item.parent.disabled,
                option: item.parent,
                type: 'parent',
            },
        };
    }
    return { parentProps, updatedLastGroupIndex };
};
//# sourceMappingURL=parent-props.js.map